import { render, staticRenderFns } from "./fileTranslation.vue?vue&type=template&id=9ba54078&scoped=true&"
import script from "./fileTranslation.vue?vue&type=script&lang=js&"
export * from "./fileTranslation.vue?vue&type=script&lang=js&"
import style0 from "./fileTranslation.vue?vue&type=style&index=0&id=9ba54078&scoped=true&lang=css&"
import style1 from "./fileTranslation.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ba54078",
  null
  
)

export default component.exports